export enum AUTH_ROLE {
	// General user, can only play their game
	ADMIN = '2',
	GUEST = '1',
}
